import RubricaElenco from './RubricaElenco';

class RubricaElencoCompleto extends RubricaElenco {

    constructor(){
        super();
        this.doDrawRow = this.doDrawRow.bind(this);
    }

    doDrawRow(row, data){
        // let doc = data.doc;
        row.height += 7;
        super.doDrawRow(row, data);
    }

    createPdf(items){

        const columns = [
            {title: "Organizzazione", dataKey: "org"},
            {title: "Dipartimento", dataKey: "dip"},
            {title: "Soggetto", dataKey: "sog"},
            {title: "Status", dataKey: "status"}
        ];
        let rows = [];
        items.map((item) => {
            let lv = '';
            /*
            Organizzazione
             */
            let ito = item.idDipartimento.idOrganizzazione;
            let org = ito.nomeCompleto + ' \n';
            lv = this.getIndirizzoCompleto(ito);
            org += lv.trim() ? lv + '\n':'';
            lv = this.getCFPiva(ito);
            org += lv.trim() ? lv + '\n':'';
            lv = (this.getEmailPec(ito) + (ito.web ? ' ' + ito.web:''))
            org += lv ? lv + '\n' : '';
            lv = (this.getNumeriTelefono(ito) + (ito.fax ? ' fax:'+ ito.fax:''))
            org += lv ? lv + '\n' : '';
            org += ito.note ? ito.note + '\n' : '';
            org += this.getCreazModif(ito);

            /*
            Dipartimento
             */
            let itd = item.idDipartimento;
            let dip = itd.nomeCompleto + '\n';
            lv = this.getIndirizzoCompleto(itd);
            dip += lv ? lv + '\n':'';
            lv = this.getCFPiva(itd)
            dip += lv ? lv + '\n':'';
            lv = (this.getEmailPec(itd) + (itd.web ? ' ' + itd.web:''))
            dip += lv ? lv + '\n' : '';
            lv = (this.getNumeriTelefono(itd) + (itd.fax ? ' fax:'+ itd.fax:''))
            dip += lv ? lv + '\n' : '';
            dip += itd.note ? itd.note + '\n' : '';
            dip += this.getCreazModif(itd);

            /*
            Soggetto
             */
            let its = item;
            let sog = (its.tit ? its.tit + ' ': '' ) + its.nomeCognome + ' ' + this.getTipoSoggettoCompatto(its) + ' ' + (this.getCFPiva(its) ? '('+this.getCFPiva(its)+')':'')  + '\n';
            lv = this.getIndirizzoCompleto(its)
            sog += lv ? lv + '\n':'';
            lv = (this.getEmailPec(its) +  (its.web ? ' ' +its.web:''))
            sog += lv ? lv + '\n' : '';
            lv = (this.getNumeriTelefono(its) + (its.fax ? ' fax:'+ its.fax:''))
            sog += lv ? lv + '\n' : '';
            sog += its.note ? its.note + '\n' : '';
            sog += this.getCreazModif(its);

            let it = {
                org: org,
                dip: dip,
                sog: sog,
                status: this.getTipoSoggettoCompatto(item),
            };
            rows.push(it);
            return 0;
        });

        super.createPdf(columns, rows,
            {
                drawRow: this.doDrawRow,
                margin: [20, 20, 50, 20],
                columnStyles: {
                    org: {columnWidth: 300},
                    dip: {columnWidth: 200},
                    sog: {columnWidth: 'auto'},
                    status: {halign: 'center', columnWidth: 40},
                }
            });
    }
}

export default RubricaElencoCompleto;


/** WEBPACK FOOTER **
 ** ./src/pdf/RubricaElencoCompleto.js
 **/